<template>
  <v-dialog
    v-if="dialog"
    v-model="editDialog"
    v-bind="$attrs"
    :scrollable="isScrollable"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="cancelAction"
  >
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="loading || !xmlSource">
     <v-skeleton-loader
        class="mx-auto d-none d-md-block"
        type="article, actions"
      ></v-skeleton-loader>

      <v-skeleton-loader
        class="mx-auto d-md-none"
        type="list-item-avatar, list-item-three-line, table-tfoot, list-item-two-line, article, table-heading, list-item-three-line, actions"
      ></v-skeleton-loader>
    </div>
    <v-card v-else>
      <v-card-title class="px-3 py-0 px-md-5 py-md-1">
        <span class="text-subtitle-2 text-sm-subtitle-1 text-md-h6 text-lg-h5 font-weight-bold">{{xmlTitle}}</span>
        <v-spacer></v-spacer>
        <v-btn
          text
          icon
          title="Cancelar"
          class="my-2"
          @click="cancelAction"
        >
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5 px-3 px-sm-4 px-md-6">
        
        <pre lang="xml" v-if="canPrettifyXml()">{{prettifyXml(xmlSource)}}</pre>
        <pre lang="xml" v-else>{{xmlSource}}</pre>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-2 py-0 px-md-4 py-md-1">
        <v-btn class="my-2" @click="cancelAction">
          {{editCancelButtonLabel}}
        </v-btn>

        <v-spacer></v-spacer>
        
        <!-- <slot name="action1"></slot>
        <slot name="action2"></slot>
        <slot name="action3"></slot>

        <v-btn color="success" class="my-2" @click="confirmAction" v-if="!readOnly">
          {{editSaveButtonLabel}}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn> -->
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltipDownload }">
            <a style="text-decoration: none;"
              v-if="xmlSource"
              :href="getXmlHref(xmlSource)"
              :download="xmlTitle + '.xml'"
            >
              <v-btn v-on="{ ...tooltipDownload }">
                Download
                <v-icon
                  small
                  class="mr-2"
                  right
                >
                  mdi-download
                </v-icon>
              </v-btn>
            </a>
          </template>
          <span>{{'Download do arquivo ' + xmlTitle + '.xml'}}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on: dialog }" >
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            v-on="{ ...tooltip, ...dialog }"
            class="mx-1"
            @click="openAction"
          >
          <!-- :title="editButtonLabel" -->
            <!-- mdi-file-eye -->
            mdi-file-code
          </v-icon>
        </template>
        <span>{{'Visualizar ' + xmlTitle}}</span>
      </v-tooltip>
    </template>
  </v-dialog>
  <div v-else class="col">
    Em desenvolvimento!
  </div>
</template>

<script>

export default {
  data() {
    return {
      editDialog: null
    };
  },
  props: {
    xmlSource: {
      type: String
    },
    nestedDialog: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: true
    },
    formErrors: {
      type: Array,
      default: () => []
    },
    isScrollable: {
      type: Boolean,
      default: true
    },
    xmlTitle: {
      type: String,
      default: "Visualização de arquivo PDF"
    },
    editButtonLabel: {
      type: String,
      default: "Editar"
    },
    editCancelButtonLabel: {
      type: String,
      default: "Cancelar"
    },
    editSaveButtonLabel: {
      type: String,
      default: "Salvar Alterações"
    },
    loading: {
      type: Boolean,
      default: true
    },
    pageLoading: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    }
  },
  components: {
  },
  methods: {
    cancelAction: function(){
      this.editDialog = false
      this.$emit("edit-cancel-action")
    },
    confirmAction: function(){
      this.$emit("edit-confirm-action")
    },
    openAction: function() {
      this.$emit("xml-open-action")
    },
    closeDialog: function() {
      this.editDialog = false;
    },
    getXmlHref: function(xml) {
      let bb = new Blob([xml], {type: 'text/plain'});
      return window.URL.createObjectURL(bb);
    }, 
    getXmlData: function(xmlStr) {

      // console.log("XML string",xmlStr );
      let parseXml;

      if (window.DOMParser) {
        parseXml = ( new window.DOMParser() ).parseFromString(xmlStr, "text/xml");
      } else if (typeof window.ActiveXObject != "undefined" && new window.ActiveXObject("Microsoft.XMLDOM")) {
        var xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
            xmlDoc.async = "false";
            xmlDoc.loadXML(xmlStr);
            parseXml = xmlDoc;
      } else {
          parseXml = null; 
      }
      // console.log("Parseado", parseXml);
      return parseXml;
    },
    prettifyXml: function(sourceXml) {
      var xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
      var xsltDoc = new DOMParser().parseFromString([
          // describes how we want to modify the XML - indent everything
          '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
          '  <xsl:strip-space elements="*"/>',
          '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
          '    <xsl:value-of select="normalize-space(.)"/>',
          '  </xsl:template>',
          '  <xsl:template match="node()|@*">',
          '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
          '  </xsl:template>',
          '  <xsl:output indent="yes"/>',
          '</xsl:stylesheet>',
      ].join('\n'), 'application/xml');

      var xsltProcessor = new XSLTProcessor();    
      xsltProcessor.importStylesheet(xsltDoc);
      var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
      var resultXml = new XMLSerializer().serializeToString(resultDoc);
      return resultXml;
    },
    canPrettifyXml() {
      if(/Chrome|Safari/i.test(navigator.userAgent)) {
        return true
      } 
      return false
    },
  },
};
</script>

<style scoped></style>
